module.exports = __webpack_public_path__ + "img/ns_power.891296ed.jpg";